export const browserSessionKey = 'mc_tool_browser_session_id';
// Keep this non-secret mode latch after expiry/logout. Original UI navigation
// must never silently change a scoped tab into an ordinary OIDC application.
export const browserModeKey = 'mc_tool_browser_mode';

function requireBrowserPath(path: string): void {
  const url = new URL(path, 'https://browser.invalid');
  if (!path.startsWith('/api/browser/') || url.origin !== 'https://browser.invalid'
    || !url.pathname.startsWith('/api/browser/') || url.hash) {
    throw new Error('Unsupported browser route.');
  }
}

export function browserSessionHeader(): Record<string, string> {
  const sessionId = sessionStorage.getItem(browserSessionKey);
  if (!sessionId) throw new Error('Open a tool-token login link to start a browser session.');
  return { 'X-Browser-Session-Id': sessionId };
}

export async function browserGet<T>(path: string): Promise<T> {
  requireBrowserPath(path);
  const response = await fetch(path, { credentials: 'same-origin', cache: 'no-store', headers: browserSessionHeader() });
  if (!response.ok) throw new Error(response.status === 401 ? 'Browser session expired or revoked.' : 'Browser request failed.');
  return response.json() as Promise<T>;
}

export async function browserMutate<T>(path: string, csrf: string, method: 'POST' | 'DELETE', body?: unknown): Promise<T | undefined> {
  requireBrowserPath(path);
  const response = await fetch(path, {
    method, credentials: 'same-origin', cache: 'no-store',
    headers: { 'Content-Type': 'application/json', 'X-Browser-CSRF': csrf, ...browserSessionHeader() },
    body: body === undefined ? undefined : JSON.stringify(body)
  });
  if (!response.ok) throw new Error(response.status === 401 ? 'Browser session expired or revoked.' : 'Browser action was denied.');
  return response.status === 204 ? undefined : response.json() as Promise<T>;
}
